export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "Instans av dimension";
};

export const detailUrl = ({ id }) => {
  return `/rental-notifications/invoicing-objects/custom-dimensions-entries/${id}`;
};
